module.exports = __webpack_public_path__ + "static/images/components/ButtonSimple/images/button-simple-external-icon.02c15e55.png";


//////////////////
// WEBPACK FOOTER
// ./components/ButtonSimple/images/button-simple-external-icon.png
// module id = 2572
// module chunks = 11